/**
 *  Cabin View Common functionality
 *  Main functionality belongs to Ocean Cruise
 *  The following flows are using CabinInformationView as a Parent View
 *  - River Cruise
 */

var CabinInformationView = Backbone.View.extend({
  events: {
    "click [data-cabin-details-trigger]": "displayCabinDetails",
    "click [data-results-toggle]": "toggleSelectedCabin",
    "click [data-cabin-selector]": "trackSelectedCabin",
    "click [data-cabin-select]": "dynamicSelector",
    "click [data-cabin-trigger]": "highlightSelectedCabin",
    "change [pattern='[A-Z0-9]+']": "convertToUpperCase"
  },

  displayCabinDetails: function(event) {
    var url = $(event.currentTarget).data("cabin-details-trigger");

    var Dialog = this.containers.cabinDetails
      .data("dialog-async", url)
      .component();

    Dialog.reflow().open();
  },

  trackSelectedCabin: function(e) {
    let previousCabin = this.selectedCabin;

    let currentCabin = this.$("[data-cabin-selector]:checked");
    let currentWrapper = currentCabin.parents("[data-scrollable-wrapper]");
    this.selectedCabin = currentCabin.attr("data-cabin-selector");

    if (this.selectedCabin) {
      // using the currentTarget to scroll inside the div
      if (typeof e !== "undefined") {
        let currentID = $(e.currentTarget).attr("id");
        let currentLabel = $("[for='" + currentID + "']");

        if (currentWrapper.length) {
          currentWrapper.animate(
            {
              scrollTop:
                currentLabel.offset().top +
                currentWrapper.scrollTop() -
                currentWrapper.offset().top
            },
            "slow"
          );
        }
      }

      if (this.isInitialized) {
        if (this.$el.is("[data-cabin-disabled-autosubmit]")) {
          // declaring all the margins that can affect the
          // scrolling position of the panel submit area
          let cabinWrapper = $(
            "[data-cabin-wrapper].is-expanded [data-panel-submit]"
          );

          cabinWrapper = cabinWrapper.length
            ? cabinWrapper
            : $("[data-panel-submit]");

          let threadBottomContainer = this.$("[data-scroll-bottom]");

          if (this.settings.threads > 1) {
            threadBottomContainer = this.$el
              .closest("[data-collapser-wrapper]")
              .find("[data-panel-submit]");
          }

          let panelSubmit = cabinWrapper.length
            ? cabinWrapper.first()
            : threadBottomContainer;

          let bottomPosition =
            threadBottomContainer.offset().top -
            window.innerHeight +
            panelSubmit.outerHeight(true);

          $("html, body")
            .stop()
            .animate(
              {
                scrollTop: Math.abs(bottomPosition)
              },
              1000
            );
        } else {
          // This takes out the validation of the manual booking input and submits the form
          this.$("[data-cabin-input]")
            .removeAttr("required")
            .val("");

          $("[data-form-main]").submit();
        }
      }

      if (!this.allowedDuplicateCabinNumber(this.selectedCabin)) {
        Backbone.Events.trigger("cabinSelected", {
          cabin: this.selectedCabin,
          id: this.settings.id
        });

        if (previousCabin) {
          Backbone.Events.trigger("cabinDeselected", {
            cabin: previousCabin,
            id: this.settings.id
          });
        }
      }
    }
  },

  dynamicSelector: function(e) {
    // this is used to mimic the label behavior,
    // replaced on ADA project
    let currentSelector = $(e.currentTarget);
    let currentSelectorTarget = currentSelector.attr("data-cabin-id");

    $(
      "label[for='" + currentSelectorTarget + "'], #" + currentSelectorTarget
    ).trigger("click");
  },

  /**
   * This method toggles the selected cabin when switching between results views
   */
  toggleSelectedCabin: function() {
    var selectedView = this.$("[data-results-toggle]:checked").data(
      "resultsToggle"
    );

    if (this.selectedCabin) {
      this.$("[data-cabin-selector]").removeAttr("checked");
      this.$(
        '[data-results-view="' +
          selectedView +
          '"] [data-cabin-selector="' +
          this.selectedCabin +
          '"]'
      ).prop("checked", true);
    }
  },

  /**
   * Makes the eye icon to be selected in all views when active and does the
   * offset animation for the map to center the bubble
   * @param event It comes from the eye icon on each cabin with interactive view available
   */
  highlightSelectedCabin: function(event) {
    let currentEvent = $(event.currentTarget);
    let currentSettings = currentEvent.data();

    let currentCabin = currentSettings.cabinTrigger;
    let currentDeck = currentSettings.collapserTrigger;

    // Unselecting triggers
    this.$("[data-cabin-trigger]").removeClass("is-active");

    // Selecting currentTrigger
    this.$("[data-cabin-trigger ='" + currentCabin + "']").addClass(
      "is-active"
    );

    // This in charge of triggering the interactive view button on the viewing mode
    this.$("#" + currentSettings.cabinView).trigger("click");

    // gathering all available triggers in the interactive map
    let actionCollection = this.$(
      "[data-interactive-view] [for], [data-interactive-view] [data-cabin-id]"
    );

    actionCollection.removeClass("is-active");

    let activeCabin;

    // checking for all available triggers and pushing them into an array
    $.each(actionCollection, function(key, item) {
      if (
        $(item).data("cabinId") === currentCabin ||
        $(item).attr("for") === currentCabin
      ) {
        activeCabin = $(item);
        return false;
      }
    });

    // Making bubble on interactive map to be active
    if (activeCabin && activeCabin.length) {
      activeCabin.addClass("is-active");

      // this triggers the change in the dropdown
      // for decks on the interactive view
      this.$("[data-dropdown-cabin-id='" + currentDeck + "']").trigger("click");

      // runs animation to be in focus the bubble in the map
      setTimeout(() => {
        $("html,body").animate(
          {
            scrollTop: activeCabin.offset().top - 150
          },
          "slow"
        );
      }, 300);
    }
  },

  allowedDuplicateCabinNumber: function(cabinNumber) {
    switch (cabinNumber) {
      case "GTY":
      case "GUAR":
      case "GUARANTEED":
      case "GUA":
      case "G00000":
      case "WTL":
      case "WLT":
      case "WAITL":
      case "SH":
      case "SHR":
      case "SHRD":
        return true;
    }

    return false;
  },

  processCabinSelection: function(data) {
    if (this.settings.id != data.id) {
      this.$('[data-cabin-selector="' + data.cabin + '"]')
        .removeAttr("checked")
        .attr("disabled", true);
    }
  },

  processCabinDeselection: function(data) {
    if (this.settings.id != data.id) {
      this.$('[data-cabin-selector="' + data.cabin + '"]').removeAttr(
        "disabled"
      );
    }
  },
  //The cabin number input has validation to allow only uppercase letters. In case the rules for validation will change, the function will run only if specific pattern for uppercase is present
  convertToUpperCase: function(e) {
    e.currentTarget.value = e.currentTarget.value.toLocaleUpperCase();
  },

  initialize: function() {
    this.settings = {
      urls: {}
    };

    if (this.$el.data("settings")) {
      this.settings = this.settings = $.extend(
        true,
        this.settings,
        this.$el.data("settings")
      );
    }

    this.containers = {
      cabinDetails: null
    };

    this.containers.cabinDetails = this.$("[data-cabin-details-modal]");

    this.selectedCabin = null;

    Backbone.Events.on("cabinSelected", this.processCabinSelection, this);
    Backbone.Events.on("cabinDeselected", this.processCabinDeselection, this);

    this.trackSelectedCabin();

    this.isInitialized = true;
  }
});

module.exports = CabinInformationView;
